import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#374047] text-white pt-16 pb-8" data-id="element-47">
      <div className="container mx-auto px-4 md:px-6" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-49">
          {/* Logo and about */}
          <div data-id="element-50">
            <Link to="/" className="inline-block mb-4" data-id="element-51">
              <span className="text-2xl font-bold text-white" data-id="element-52">
                Desta<span className="text-[#FF6B65]" data-id="element-53">Meet</span>
              </span>
            </Link>
            <p className="text-gray-300 mb-4" data-id="element-54">
              The Premier Destination Management Company, creating elevated
              group experiences that foster connection, reward excellence, and
              elevate organizational impact.
            </p>
            <div className="flex space-x-4" data-id="element-55">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#FF6B65] transition-colors" aria-label="Instagram" data-id="element-56">
                <InstagramIcon className="h-5 w-5" data-id="element-57" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#FF6B65] transition-colors" aria-label="LinkedIn" data-id="element-58">
                <LinkedinIcon className="h-5 w-5" data-id="element-59" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-60">
            <h3 className="text-lg font-semibold mb-4" data-id="element-61">Quick Links</h3>
            <ul className="space-y-2" data-id="element-62">
              <li data-id="element-63">
                <Link to="/solutions" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-64">
                  Solutions
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/agenda" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-66">
                  Sample Agenda
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/venues" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-68">
                  Venues
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/packages" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-70">
                  Packages & Pricing
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/corporate-travel-kits" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-72">
                  Corporate Travel Kits
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/learning-development" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-74">
                  Learning and Development
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/destapass" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-76">
                  DestaPass - Wedding Platform
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/wedding-kickoff" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-78">
                  DestaPass - Wedding Kickoff
                </Link>
              </li>
            </ul>
          </div>

          {/* Partner Programs */}
          <div data-id="element-79">
            <h3 className="text-lg font-semibold mb-4" data-id="element-80">Partner Programs</h3>
            <ul className="space-y-2" data-id="element-81">
              <li data-id="element-82">
                <Link to="/trainer-partner-program" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-83">
                  Trainer Partner Program
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/vip-partner-program" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-85">
                  VIP Experience Partners
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/creator-summits" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-87">
                  Creator Summits
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/soul-flow" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-89">
                  Soul Flow - Luxury Retreat
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/elevate-impact" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-91">
                  SKO Complimentary Luxury Retreat
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/ai-leaders-retreat" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-93">
                  AI Leaders Luxury Retreat
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/case-stories" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-95">
                  Case Stories
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/insights" onClick={scrollToTop} className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-97">
                  Insight Hub
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-98">
            <h3 className="text-lg font-semibold mb-4" data-id="element-99">Contact</h3>
            <ul className="space-y-2 mb-4" data-id="element-100">
              <li className="flex items-center" data-id="element-101">
                <PhoneIcon className="h-4 w-4 mr-2 text-[#FF6B65]" data-id="element-102" />
                <a href="tel:+19052152109" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-103">
                  +1 (905) 215-2109
                </a>
              </li>
              <li className="flex items-center" data-id="element-104">
                <MailIcon className="h-4 w-4 mr-2 text-[#FF6B65]" data-id="element-105" />
                <a href="mailto:experience@destameet.com" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-106">
                  experience@destameet.com
                </a>
              </li>
            </ul>
            <a href="https://api.whatsapp.com/send?phone=19052152109" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 bg-[#25D366] text-white rounded-md hover:bg-opacity-90 transition-colors" data-id="element-107">
              <span data-id="element-108">WhatsApp Chat</span>
            </a>
            <div className="mt-4" data-id="element-109">
              <Link to="/about" className="text-gray-300 hover:text-[#FF6B65] transition-colors text-sm" data-id="element-110">
                About & ESG
              </Link>
              <span className="text-gray-600 mx-2" data-id="element-111">•</span>
              <Link to="/contact" className="text-gray-300 hover:text-[#FF6B65] transition-colors text-sm" data-id="element-112">
                Contact / RFP
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-700" data-id="element-113">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-114">
            <p className="text-sm text-gray-400 mb-4 md:mb-0" data-id="element-115">
              &copy; {currentYear} DestaMeet. All rights reserved.
            </p>
            <div className="text-sm text-gray-400 flex flex-wrap justify-center gap-4" data-id="element-116">
              <span data-id="element-117">100% carbon-offset</span>
              <span className="hidden md:inline" data-id="element-118">•</span>
              <span data-id="element-119">Reef-restoration support</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}